import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Box, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';

import { useGetUnreadCountQuery } from '../../../redux/api/notificationsApi';
import { Paths } from '../../../shared/paths';
import { useStyles } from './InAppNotificationsNavButton.styles';

const InAppNotificationsNavButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  const { classes } = useStyles(theme);
  const { data } = useGetUnreadCountQuery(undefined, {
    pollingInterval: 60000,
  });
  const unreadCount = data?.unreadCount ?? 0;

  return (
    <Box className={classes.root}>
      <IconButton
        className={classes.iconButton}
        aria-label={t('inAppNotifications.openInbox')}
        onClick={() => navigate(Paths.inAppNotifications.root)}
        size="medium">
        <NotificationsOutlinedIcon />
      </IconButton>
      {unreadCount > 0 ? (
        <Box
          className={classes.unreadDot}
          data-testid="in-app-notifications-unread-dot"
        />
      ) : null}
    </Box>
  );
};

export default InAppNotificationsNavButton;
